/**
 * Temporary mock for HubSpot metadata overview until connection / sync API exists.
 */
export function useHubspotMetadataOverviewMock() {
    return {
        hasConfiguration: true,
        lastSync: 'Synced 11:21pm 26.01.23',
    };
}
